var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDrag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6_26)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7.50342,
    y: 1,
    width: 15.3425,
    height: 15.4545,
    rx: 1,
    stroke: "#140A9A",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    y: 6.54546,
    width: 17.3425,
    height: 17.4545,
    rx: 2,
    fill: "#140A9A"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_6_26)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.2193 4.46805L15.7348 4.45519C15.6752 4.45495 15.6161 4.46658 15.561 4.48943C15.5058 4.51228 15.4558 4.54589 15.4136 4.58832C15.3714 4.63075 15.338 4.68116 15.3153 4.73665C15.2926 4.79213 15.2811 4.85159 15.2813 4.9116C15.2817 5.03168 15.3292 5.14674 15.4136 5.23166C15.498 5.31657 15.6123 5.36443 15.7316 5.36479L18.0149 5.37443L11.5034 11.928C11.4187 12.0133 11.3711 12.1289 11.3711 12.2494C11.3711 12.37 11.4187 12.4856 11.5034 12.5708C11.5881 12.6561 11.703 12.704 11.8228 12.704C11.9425 12.704 12.0574 12.6561 12.1421 12.5708L18.6728 5.99797L18.6696 8.32178C18.6694 8.38178 18.6809 8.44124 18.7036 8.49673C18.7263 8.55221 18.7597 8.60262 18.8019 8.64506C18.844 8.68749 18.8941 8.72109 18.9493 8.74394C19.0044 8.76679 19.0635 8.77843 19.1231 8.77819C19.1827 8.77843 19.2418 8.76679 19.2969 8.74394C19.352 8.72109 19.4021 8.68749 19.4443 8.64506C19.4864 8.60262 19.5198 8.55221 19.5425 8.49673C19.5652 8.44124 19.5768 8.38178 19.5766 8.32178L19.5734 5.83083C19.5731 5.46947 19.4304 5.12297 19.1765 4.86745C18.9226 4.61192 18.5784 4.46827 18.2193 4.46805Z",
    fill: "#140A9A"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_6_26)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.1354 4.55897L15.6509 4.54612C15.5913 4.54587 15.5322 4.55751 15.4771 4.58036C15.4219 4.60321 15.3718 4.63682 15.3297 4.67925C15.2875 4.72168 15.2541 4.77209 15.2314 4.82757C15.2087 4.88306 15.1972 4.94252 15.1974 5.00252C15.1978 5.12261 15.2453 5.23767 15.3297 5.32258C15.414 5.4075 15.5284 5.45536 15.6477 5.45571L17.931 5.46536L11.4195 12.019C11.3348 12.1042 11.2872 12.2198 11.2872 12.3404C11.2872 12.4609 11.3348 12.5765 11.4195 12.6618C11.5042 12.747 11.6191 12.7949 11.7389 12.7949C11.8586 12.7949 11.9735 12.747 12.0582 12.6618L18.5889 6.0889L18.5857 8.41271C18.5855 8.47271 18.597 8.53217 18.6197 8.58766C18.6424 8.64314 18.6758 8.69355 18.718 8.73598C18.7601 8.77841 18.8102 8.81202 18.8653 8.83487C18.9205 8.85772 18.9796 8.86936 19.0392 8.86911C19.0988 8.86936 19.1579 8.85772 19.213 8.83487C19.2681 8.81202 19.3182 8.77841 19.3604 8.73598C19.4025 8.69355 19.4359 8.64314 19.4586 8.58766C19.4813 8.53217 19.4929 8.47271 19.4926 8.41271L19.4895 5.92176C19.4892 5.5604 19.3465 5.2139 19.0926 4.95837C18.8387 4.70285 18.4945 4.5592 18.1354 4.55897Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6_26"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_6_26"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10.8741,
    height: 10.8741,
    fill: "white",
    transform: "matrix(0.704826 -0.70938 0.704826 0.70938 7.67123 8.7139)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_6_26"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.64771,
    height: 10.8741,
    fill: "white",
    transform: "matrix(0.704826 -0.70938 0.704826 0.70938 7.58733 8.80481)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrag);
export default __webpack_public_path__ + "static/media/Drag.17518f8d69bc36f22ae109a7d1d49753.svg";
export { ForwardRef as ReactComponent };